// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style for the Upload Button -- START -- */
.file-uploader-upload {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-width: 10rem;
	transition: 0.3s ease-in-out;
}

.file-uploader-upload:hover {
	transform: scale(1.08);
	transition: 0.3s ease;
	color: rgb(28, 119, 195);
}

.file-uploader-upload i {
	font-size: 1.5em;
	color: rgb(28, 119, 195);
}

.file-uploader-upload input {
	display: none;
}

.file-uploader-upload span {
	margin-top: 0.3rem;
	font-size: 0.95rem;
}
/* Style for the Upload Button -- END -- */

/* Style for the Upload Lists -- START -- */
.file-uploader-list {
	cursor: default;
	display: flex;
	align-content: flex-start;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	margin-bottom: 1.5rem;
}

.file-uploader-list-title {
	margin-top: 3rem;
	font-weight: 600;
	font-size: 1.195em;
}

.file-uploader-list ul {
	border: 1px solid rgb(180, 180, 180);
	font-size: 1.225em;
	width: 100%;
	padding: 0;
}

.file-uploader-list li {
	list-style: none;
	line-height: 1.7rem;
	border-bottom: 2px solid rgb(202, 202, 202);
	padding: 0.6rem 0 0.6rem 0.75rem;
}

.file-uploader-list li:last-child {
	border-bottom: none;
}
/* Style for the Upload Lists -- END -- */
`, "",{"version":3,"sources":["webpack://./src/components/fileUploader/file-uploader.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;CACC,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CAGC,sBAAsB;CACtB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA,0CAA0C;;AAE1C,2CAA2C;AAC3C;CACC,eAAe;CACf,aAAa;CACb,yBAAyB;CACzB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,2CAA2C;CAC3C,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;AACA,yCAAyC","sourcesContent":["/* Style for the Upload Button -- START -- */\n.file-uploader-upload {\n\tcursor: pointer;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmax-width: 10rem;\n\ttransition: 0.3s ease-in-out;\n}\n\n.file-uploader-upload:hover {\n\t-webkit-transform: scale(1.08);\n\t-ms-transform: scale(1.08);\n\ttransform: scale(1.08);\n\ttransition: 0.3s ease;\n\tcolor: rgb(28, 119, 195);\n}\n\n.file-uploader-upload i {\n\tfont-size: 1.5em;\n\tcolor: rgb(28, 119, 195);\n}\n\n.file-uploader-upload input {\n\tdisplay: none;\n}\n\n.file-uploader-upload span {\n\tmargin-top: 0.3rem;\n\tfont-size: 0.95rem;\n}\n/* Style for the Upload Button -- END -- */\n\n/* Style for the Upload Lists -- START -- */\n.file-uploader-list {\n\tcursor: default;\n\tdisplay: flex;\n\talign-content: flex-start;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tflex-direction: column;\n\tmargin-bottom: 1.5rem;\n}\n\n.file-uploader-list-title {\n\tmargin-top: 3rem;\n\tfont-weight: 600;\n\tfont-size: 1.195em;\n}\n\n.file-uploader-list ul {\n\tborder: 1px solid rgb(180, 180, 180);\n\tfont-size: 1.225em;\n\twidth: 100%;\n\tpadding: 0;\n}\n\n.file-uploader-list li {\n\tlist-style: none;\n\tline-height: 1.7rem;\n\tborder-bottom: 2px solid rgb(202, 202, 202);\n\tpadding: 0.6rem 0 0.6rem 0.75rem;\n}\n\n.file-uploader-list li:last-child {\n\tborder-bottom: none;\n}\n/* Style for the Upload Lists -- END -- */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
